import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function ArrowDownFooterIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg width={width || 7} height={height || 4.455} viewBox="0 0 7 4.455">
      <path
        d="M11.766 192h6.058a.537.537 0 01.332.9l-3.028 3.4a.436.436 0 01-.666 0l-3.028-3.4a.537.537 0 01.332-.9z"
        transform="translate(-11.295 -192)"
        fill={color || "#555"}
      />
    </svg>
  );
}
